import { Chess } from "@chesshotel/chess";
import { exchangeEvaluation, getFen, uci2move } from "./util.js";
import { isValidFenMove } from "./tactics/util.js";
import { ChessTermType, TermAction, } from "@chesshotel/types";
function detectCheck(fen, move) {
    const chess = new Chess(fen);
    const moveResult = chess.move(uci2move(move));
    if (!moveResult)
        return null;
    if (chess.inCheck()) {
        return {
            term: ChessTermType.CHECK,
            move: moveResult,
        };
    }
    return null;
}
export function detectPositiveCheck(position, lastPosition) {
    const userMove = detectCheck(lastPosition.fen, position.move);
    if (userMove) {
        return {
            ...userMove,
            termAction: TermAction.PERFORM,
        };
    }
}
export function detectNegativeCheck(position, lastPosition) {
    const userMove = detectCheck(lastPosition.fen, position.move);
    const bestMove = detectCheck(lastPosition.fen, lastPosition.bestMove);
    if (bestMove && !userMove) {
        return {
            ...bestMove,
            termAction: TermAction.MISS,
        };
    }
    if (bestMove && userMove) {
        return {
            ...bestMove,
            termAction: TermAction.BETTER_WAY,
        };
    }
    const opponentMove = position.pvMoves[0];
    const user = detectCheck(position.fen, opponentMove);
    if (user) {
        const bestFen = getFen(lastPosition.fen, lastPosition.pvMoves[0]);
        const isValid = isValidFenMove(bestFen, opponentMove);
        if (!isValid) {
            return {
                ...user,
                termAction: TermAction.ALLOW,
            };
        }
        const best = detectCheck(bestFen, opponentMove);
        if (!best) {
            return {
                ...user,
                termAction: TermAction.ALLOW,
            };
        }
        const fenAfter = getFen(bestFen, opponentMove);
        const to = uci2move(opponentMove).to;
        const evaluation = exchangeEvaluation(fenAfter, to, {
            backtrackBadMoves: true,
        });
        if (evaluation.gain > 0) {
            return {
                ...user,
                termAction: TermAction.ALLOW,
            };
        }
    }
}
//# sourceMappingURL=check.js.map